package com.alpha.showcase.common.ui.confetti

enum class ConfettiType {
    Celebration,
    Success,
    Burst,
}
